export default __webpack_public_path__ + "static/media/CaylaSneaker_Wide.3b12fb63.jpg";